import BeelineLanding from '../beelineLp/BeelineLanding';

export default function Beeline2() {
  return <BeelineLanding lpKey="beeline2" lpName="KG Beeline 2 LP" variant={2} />;
}
